import WaitingListTable from './WaitingListTable.component';

export default WaitingListTable;
